import React from "react";
import { Box, Typography } from "@mui/material";
import { CarTableMemoTable } from "@app/components/Table";
import { getAccountsTotals } from "@app/features/assets/account.utils";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { CarTotalLabel } from "@app/components/TotalLabel";
import { useAccount } from "@app/features/assets/useAccount";
import { useExpandSingle } from "@app/hooks/useExpand";
import {
  CarAccordion,
  CarAccordionDetails,
  CarAccordionSummary,
} from "@app/components/Accordion";
import { IntegratorAccountRow } from "./IntegratorAccountRow";
import { CarTooltipBox } from "@app/components/TooltipBox";
import { pendoClasses } from "@app/core/thirdParty/pendo";

export const IntegratorAccountsSection = React.memo(() => {
  const expand = useExpandSingle(`IntegratorAccountsSection`, false);
  const data = useAccount();
  const totals = getAccountsTotals(data.integrationItems);

  return (
    <CarAccordion {...expand}>
      <CarAccordionSummary>
        <Typography variant="h5SSemiBold">
          Integrator Accounts
          <CarTooltipBox
            sx={{ display: "inline", ml: 0.5, mt: 0.25 }}
            className={pendoClasses.planInputIntegratorAccounts}
          />
        </Typography>
      </CarAccordionSummary>
      <CarAccordionDetails
        sx={{
          backgroundColor: "gray1",
          pl: 7,
          pr: 3,
          py: 6,
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TablePlaceHolder isLoading={data.isLoading}>
          <CarTableMemoTable
            items={data.integrationItems}
            rowComponent={IntegratorAccountRow}
            onChange={data.handleChange}
            onDelete={data.handleDelete}
            pendoPrefix="integrator_accounts"
          />
        </TablePlaceHolder>
        <Box
          sx={{
            ml: 1.5,
            mt: 6,
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
          }}
        >
          <CarTotalLabel
            variant="h5SBold"
            label="Total Value of Integrator Accounts"
            value={totals.marketValue}
          />
          <CarTotalLabel
            variant="h5SBold"
            label="Total Annual Savings of Integrator Accounts"
            value={data.annualSavings.integrated}
          />
        </Box>
      </CarAccordionDetails>
    </CarAccordion>
  );
});
